// <kahi-video>: fetches and plays its muted clip only while on screen, pauses it off screen,
// and never plays with prefers-reduced-motion. The poster underneath shows until playback starts.
// Its pause / play button ([data-k-video-toggle="<id>"], inside the video or next to its link)
// appears once the clip plays; a clip the visitor paused stays paused when it scrolls back in.
class KahiVideo extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video[data-src]');
    if (!this.video || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return this.video.pause();
      if (!this.userPaused) this.play();
    }, { rootMargin: '200px 0px' });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  get toggles() {
    return document.querySelectorAll(`[data-k-video-toggle="${this.id}"]`);
  }

  play() {
    if (!this.video.src) this.video.src = this.video.dataset.src;
    this.video.play().then(() => {
      this.classList.add('is-playing');
      this.sync(false);
    }).catch(() => {});
  }

  toggle() {
    this.userPaused = !this.video.paused;
    if (this.userPaused) {
      this.video.pause();
      this.sync(true);
    } else {
      this.play();
    }
  }

  sync(paused) {
    for (const button of this.toggles) {
      button.hidden = false;
      button.toggleAttribute('data-paused', paused);
      button.setAttribute('aria-label', paused ? button.dataset.labelPlay : button.dataset.labelPause);
    }
  }
}

if (!customElements.get('kahi-video')) {
  customElements.define('kahi-video', KahiVideo);
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-k-video-toggle]');
    if (button) document.getElementById(button.dataset.kVideoToggle)?.toggle?.();
  });
}
